import { UIForm } from "mithril-ui-form";
import {
  Documentation,
  ICapabilityDataModel,
  ILabelled,
} from "./capability-model";
import { t } from "../../services/translations";

export type AssessmentItem = {
  assessmentId: string;
  items: ILabelled[];
  /** User's willingness to act on this assessment (1 = low priority, 5 = urgent) */
  actionPriority?: number;
};

export type Assessment = Partial<{
  desc: string;
  capabilityStakeholders: string[];
  otherStakeholder: string;
  documentation: Documentation[];
  taskAssessment: AssessmentItem;
  performanceAssessment: AssessmentItem;
  gaps: AssessmentItem[];
  assessmentId: unknown;
  shouldDevelop: "GO" | "NO GO";
}>;

export const assessmentModel = (model: Partial<ICapabilityDataModel>) => {
  const assessmentModel = [
    {
      id: "desc",
      label: t("desc"),
      placeholder: t("desc_cap_instr"),
      type: "textarea",
      className: "col s12",
    },
    {
      id: "capabilityStakeholders",
      label: t("shs"),
      type: "options",
      options: "stakeholders",
      checkboxClass: "col s4",
      className: "col m12",
    },
    {
      id: "otherStakeholder",
      label: t("other_stakeholder"),
      type: "text",
      show: "capabilityStakeholders = SH-12",
      className: "col s12 m6",
    },
    {
      id: "taskAssessment",
      type: "assessment",
      options: "mainTasks",
      optionLabel: "main_goals",
      assessmentOptions: "taskScale",
      assessmentLabel: "importance",
      descriptionLabel: "expl",
      overallAssessmentLabel: "max_imp",
      overallAssessment: "max",
    },
    {
      id: "performanceAssessment",
      type: "assessment",
      options: "performanceAspects",
      optionLabel: "perf_asps",
      assessmentOptions: "performanceScale",
      assessmentLabel: "level",
      descriptionLabel: "expl",
      overallAssessmentLabel: "avg_perf",
      overallAssessment: "avg",
      excludeLabel: "ignore",
    },
    {
      id: "assessmentId",
      label: t("ass_overall"),
      type: "lookup-table",
      table: "assessmentTable",
      options: "assessmentScale",
      rowId: "taskAssessment.assessmentId",
      colId: "performanceAssessment.assessmentId",
    },
    {
      id: "gaps",
      label: t("add_gap"),
      repeat: true,
      pageSize: 1,
      // onNewItem: (obj: any, i: any) => {
      //   console.log('CALLED: ' + i);
      //   console.log(obj);
      //   return {};
      // },
      type: [
        {
          id: "title",
          label: t("title"),
          type: "text",
          className: "col s8 m5 l3",
        },
        {
          id: "desc",
          label: t("desc"),
          type: "textarea",
          className: "col m7 l9",
        },
        {
          id: "gapAssessment",
          type: "assessment",
          options: "mainGaps",
          optionLabel: "prob_areas",
          assessmentOptions: "gapScale",
          assessmentLabel: "relevance",
          descriptionLabel: "expl",
          // overallAssessmentLabel: t('ass_label'),
          overallAssessment: "max",
        },
        {
          id: "documentation",
          label: t("doc"),
          repeat: true,
          pageSize: 5,
          type: [
            {
              id: "documentId",
              label: t("doc_id"),
              type: "text",
              className: "col s3 m2",
            },
            {
              id: "label",
              label: t("title"),
              type: "text",
              className: "col s6 m6",
            },
            {
              id: "link",
              label: t("url"),
              type: "url",
              className: "col s3 m4",
            },
          ],
          className: "col m12",
        },
      ],
    },
    ,
  ] as UIForm<Assessment>;
  return assessmentModel;
};
